import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-596fa689")

_pushScopeId("data-v-596fa689")
const _hoisted_1 = {
  class: "modal-content tarjeta-detalle",
  style: {"position":"realative"}
}
const _hoisted_2 = {
  class: "modal-title tituloDetalle",
  id: "staticBackdropLabel"
}
const _hoisted_3 = {
  key: 0,
  class: "fas fa-user-edit fa-lg",
  style: {"color":"#8ba7b7"}
}
const _hoisted_4 = {
  key: 1,
  style: {"color":"#0f057e"},
  class: "fas fa-user-shield fa-lg"
}
const _hoisted_5 = {
  key: 2,
  style: {"color":"#0098f3"},
  class: "fas fa-calculator fa-lg"
}
const _hoisted_6 = {
  key: 3,
  style: {"color":"#36d3b7"},
  class: "fas fa-comments-dollar fa-lg"
}
const _hoisted_7 = {
  key: 4,
  class: "fas fa-exclamation-triangle fa-lg",
  style: {"color":"#febb0e"}
}
const _hoisted_8 = {
  key: 5,
  style: {"color":"#fe541f"},
  class: "fa fa-times-circle fa-lg"
}
const _hoisted_9 = {
  key: 6,
  class: "fas fa-check-circle fa-lg",
  style: {"color":"#26bb10"}
}
const _hoisted_10 = {
  key: 7,
  style: {"color":"#fb1010"},
  class: "fab fa-creative-commons-nc fa-lg"
}
const _hoisted_11 = { class: "acciones" }
const _hoisted_12 = { class: "tabsDetalle row" }
const _hoisted_13 = /*#__PURE__*/_createVNode("a", {
  id: "enlaceRegresar",
  class: "col-sm-3"
}, null, -1)
const _hoisted_14 = {
  key: 0,
  class: "col-sm-4"
}
const _hoisted_15 = {
  key: 0,
  class: "notificarDetalle"
}
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" Notificar a: ")
const _hoisted_17 = {
  key: 0,
  class: "d-inline"
}
const _hoisted_18 = {
  key: 1,
  class: "d-inline"
}
const _hoisted_19 = {
  key: 1,
  class: "col-sm-3",
  style: {"float":"right"}
}
const _hoisted_20 = {
  class: "tab-content",
  id: "detalleRequisicionContent"
}
const _hoisted_21 = { class: "modal-footer" }
const _hoisted_22 = /*#__PURE__*/_createTextVNode(" Solicitante: ")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_TabsRequisicion = _resolveComponent("TabsRequisicion")
  const _component_ProgresoSolicitud = _resolveComponent("ProgresoSolicitud")
  const _component_DetalleDatosGenerales = _resolveComponent("DetalleDatosGenerales")
  const _component_DetalleCentroCosto = _resolveComponent("DetalleCentroCosto")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", {
      class: ["modal-header encabezadoDetalle", _ctx.claseEstatus]
    }, [
      _createVNode("h5", _hoisted_2, [
        (_ctx.estatusRequisicionId == 'EN_CREACION')
          ? (_openBlock(), _createBlock("em", _hoisted_3))
          : (_ctx.estatusRequisicionId == 'EN_AUTORIZACION' || _ctx.estatusRequisicionId == 'EN_VERIFICACION_AREA')
            ? (_openBlock(), _createBlock("em", _hoisted_4))
            : (_ctx.estatusRequisicionId == 'EN_AUTORIZACION_CXP' || _ctx.estatusRequisicionId == 'EN_VALIDACION_CXP')
              ? (_openBlock(), _createBlock("em", _hoisted_5))
              : (_ctx.estatusRequisicionId == 'EN_TESORERIA')
                ? (_openBlock(), _createBlock("em", _hoisted_6))
                : (_ctx.estatusRequisicionId == 'EN_ACLARACION')
                  ? (_openBlock(), _createBlock("em", _hoisted_7))
                  : (_ctx.estatusRequisicionId == 'RECHAZADA')
                    ? (_openBlock(), _createBlock("em", _hoisted_8))
                    : (_ctx.estatusRequisicionId == 'PAGO_REALIZADO')
                      ? (_openBlock(), _createBlock("em", _hoisted_9))
                      : (_ctx.estatusRequisicionId == 'PAGO_RECHAZADO')
                        ? (_openBlock(), _createBlock("em", _hoisted_10))
                        : _createCommentVNode("", true),
        _createTextVNode(" Detalle de la solicitud no. " + _toDisplayString(_ctx.requisicionPagoId), 1)
      ]),
      _createVNode("div", _hoisted_11, [
        (
            (_ctx.estatusRequisicionId == 'EN_ACLARACION' || _ctx.estatusRequisicionId == 'EN_CREACION') &&
            _ctx.rolUsuario == 'Solicitador'
          )
          ? (_openBlock(), _createBlock("em", {
              key: 0,
              class: "far fa-edit fa-lg position-relative iconosDetalle mt-1",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.editarRequisicion()))
            }))
          : _createCommentVNode("", true),
        (_ctx.estatusRequisicionId === 'EN_CREACION' && _ctx.rolUsuario == 'Solicitador')
          ? (_openBlock(), _createBlock("em", {
              key: 1,
              class: "far fa-trash-alt fa-lg float-end position-relative iconosDetalle mt-1",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.eliminarRequisicion()))
            }))
          : _createCommentVNode("", true)
      ])
    ], 2),
    _createVNode("div", _hoisted_12, [
      _hoisted_13,
      _createVNode(_component_TabsRequisicion, {
        class: "col-sm-5",
        style: {"margin-bottom":"0.5rem"},
        "componente-id-padre": _ctx.componenteId
      }, null, 8, ["componente-id-padre"]),
      (_ctx.rolUsuario == 'Solicitador')
        ? (_openBlock(), _createBlock("div", _hoisted_14, [
            (_ctx.estatusRequisicionId != 'EN_CREACION')
              ? (_openBlock(), _createBlock("small", _hoisted_15, [
                  _hoisted_16,
                  (_ctx.estatusRequisicionId == 'EN_VERIFICACION_AREA')
                    ? (_openBlock(), _createBlock("h6", _hoisted_17, _toDisplayString(_ctx.usuarioVerificadorArea) + "  ", 1))
                    : (_openBlock(), _createBlock("h6", _hoisted_18, _toDisplayString(_ctx.usuarioAutorizador) + " ", 1))
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (
          _ctx.rolUsuario == 'Solicitador' ||
          _ctx.rolUsuario == 'Autorizador área' ||
          _ctx.rolUsuario == 'Verificador CXP' ||
          _ctx.rolUsuario == 'Autorizador CXP' ||
          _ctx.rolUsuario == 'Tesoreria'
        )
        ? (_openBlock(), _createBlock("div", _hoisted_19))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_ProgresoSolicitud, {
      estatusRequisicionId: _ctx.estatusRequisicionId,
      tieneVerificador: _ctx.tieneVerificador,
      tieneMesaControl: _ctx.tieneMesaControl
    }, null, 8, ["estatusRequisicionId", "tieneVerificador", "tieneMesaControl"]),
    _createVNode("div", _hoisted_20, [
      _createVNode("div", {
        class: "tab-pane fade show active",
        id: _ctx.componenteId + 'datosGeneralesTab',
        role: "tabpanel",
        "aria-labelledby": "dg-tab"
      }, [
        _createVNode(_component_DetalleDatosGenerales, {
          Verificador: _ctx.tieneVerificador,
          requisicionPagoId: _ctx.requisicionPagoId,
          razonSocial: _ctx.razonSocial,
          tipoPagoId: _ctx.tipoPagoId,
          tipoPago: _ctx.tipoPago,
          fechaSolicitud: _ctx.fechaSolicitud,
          fechaPropuesta: _ctx.fechaPropuesta,
          nombreBeneficiario: _ctx.nombreBeneficiario,
          importe: _ctx.importe,
          medioInstruccion: _ctx.medioInstruccion,
          numeroFactura: _ctx.numeroFactura,
          uuid: _ctx.uuid,
          observacionInstruccion: _ctx.observacionInstruccion,
          conceptoPagoId: _ctx.conceptoPagoId,
          nombreTipoGasto: _ctx.nombreTipoGasto,
          nombreRubro: _ctx.nombreRubro,
          cuentaBeneficiario: _ctx.cuentaBeneficiario,
          bancoBeneficiario: _ctx.bancoBeneficiario,
          clabe: _ctx.clabe,
          referencia: _ctx.referencia,
          divisa: _ctx.divisa,
          rfcBeneficiario: _ctx.rfcBeneficiario,
          convenioServicioPago: _ctx.convenioServicioPago,
          documentos: _ctx.documentos,
          usuarioAutorizador: _ctx.usuarioAutorizador,
          usuarioSolicitante: _ctx.usuarioSolicitante,
          correoSolicitante: _ctx.correoSolicitante,
          correoAutorizador: _ctx.correoAutorizador,
          conceptoPagos: _ctx.conceptoPagos,
          unidadNegocio: _ctx.unidadNegocio,
          usuarioVerificadorAreaId: _ctx.usuarioVerificadorAreaId,
          usuarioVerificadorArea: _ctx.usuarioVerificadorArea,
          tipoRequisicion: _ctx.tipoRequisicion,
          claveCodigo: _ctx.claveCodigo
        }, null, 8, ["Verificador", "requisicionPagoId", "razonSocial", "tipoPagoId", "tipoPago", "fechaSolicitud", "fechaPropuesta", "nombreBeneficiario", "importe", "medioInstruccion", "numeroFactura", "uuid", "observacionInstruccion", "conceptoPagoId", "nombreTipoGasto", "nombreRubro", "cuentaBeneficiario", "bancoBeneficiario", "clabe", "referencia", "divisa", "rfcBeneficiario", "convenioServicioPago", "documentos", "usuarioAutorizador", "usuarioSolicitante", "correoSolicitante", "correoAutorizador", "conceptoPagos", "unidadNegocio", "usuarioVerificadorAreaId", "usuarioVerificadorArea", "tipoRequisicion", "claveCodigo"])
      ], 8, ["id"]),
      _createVNode("div", {
        class: "tab-pane fade",
        id: _ctx.componenteId + 'centroCosto',
        role: "tabpanel",
        "aria-labelledby": "cc-tab"
      }, [
        _createVNode(_component_DetalleCentroCosto, { centroCostos: _ctx.centroCostos }, null, 8, ["centroCostos"])
      ], 8, ["id"])
    ]),
    _createVNode("div", _hoisted_21, [
      _createVNode("p", null, [
        _hoisted_22,
        _createVNode("strong", null, _toDisplayString(_ctx.usuarioSolicitante), 1)
      ])
    ])
  ]))
})